import { Button } from "primereact/button";

export function EmployeeResourceGroupCarousel(props: any) {
    const handleClick = () => {
        window.open(
            "https://teletechinc.sharepoint.com/teams/Culture_and_Community/SitePages/ERG%20Home.aspx",
            "_blank",
            "noreferrer"
        );
    };
    return (
        <div
            className="card border-0 mb-0 pb-0"
            onClick={handleClick}
            style={{ cursor: "pointer" }}
        >
            <img
                src={props.web_url}
                className="w-100 img-fluid desktopImage"
                alt="EmployeeResourceGroups"
            />
            <img
                src={props.mobile_url}
                className="w-100 img-fluid mobileImage"
                alt="EmployeeResourceGroups"
            />
            <div className="card-img-overlay text-start">
                <div className="row mb-4">
                    <div className="col-md-12 pt-3">
                        <Button
                            style={{
                                marginBottom: "15px",
                                backgroundColor: "darkblue",
                                textAlign: "left",
                                marginLeft: 0,
                                color: "white",
                            }}
                        >
                            <a
                                href="https://teletechinc.sharepoint.com/teams/Culture_and_Community/SitePages/ERG%20Home.aspx"
                                target="_blank"
                                rel="noreferrer"
                                style={{ textDecoration: "none", color: "inherit" }}
                            >
                                Visit ERG page
                            </a>
                        </Button>
                        <>
                            <div className="row position-absolute bottom-0 start-0 mb-0 me-2 ms-2 mb-md-3 me-md-4 desktopTextWhite">
                                <div className="col-md-12">
                                    <p
                                        className="text-start pe-4"
                                        style={{ color: "black" }}
                                    >
                                        Our{" "}
                                        <strong style={{ fontSize: "large" }}>
                                            Employee Resource Groups (ERGs){" "}
                                        </strong>
                                        are groups of <br />
                                        employees who are coming together based on shared{" "}
                                        <br />
                                        characteristics and lived experiences.
                                    </p>
                                </div>
                            </div>
                        </>
                    </div>
                </div>
            </div>
        </div>
    );
}
